import { type FC, type MutableRefObject } from "react";
import { ResponsiveBlockSwitcher } from "@/shared/Components";
import type { Widget, WidgetContent } from "../../types";
import { GridItemDesktop } from "./dekstop";
import { GridItemMobile } from "./mobile";

type Props = {
  widget: Widget;
  currentWidget: WidgetContent;
  itemRefs: MutableRefObject<HTMLDivElement[]>;
  handleDelete: (id: string) => void;
  index: number;
};

export const GridItem: FC<Props> = ({ widget, currentWidget, itemRefs, handleDelete, index }) => {
  return (
    <ResponsiveBlockSwitcher
      desktop={
        <GridItemDesktop
          currentWidget={currentWidget}
          handleDelete={handleDelete}
          index={index}
          itemRefs={itemRefs}
          widget={widget}
        />
      }
      mobile={<GridItemMobile currentWidget={currentWidget} index={index} itemRefs={itemRefs} />}
    />
  );
};
